import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./speakers.css";

const Speakers = () => {
  const [speakers, setSpeakers] = useState([]);
  const location = useLocation();

  useEffect(() => {
    fetch("https://i2.sihs.org.pk/speakers/doctors.json")
      .then((response) => response.json())
      .then((data) => setSpeakers(data))
      .catch((error) =>
        console.error("Error fetching speakers data from the server:", error)
      );
  }, [location.key]);

  return (
    <div className="doctor-profiles">
      <div className="conference-image">
        <div className="heading-h2">
          <h1>Speakers</h1>
        </div>
      </div>
      {speakers.map((speaker, index) => (
        <div
          key={index}
          className={`profile-block ${index % 2 !== 0 ? "reverse" : ""}`}
        >
          <div className="profile-text">
            <h3>{speaker.title}</h3>
            <p>
              <span className="dr-name">{speaker.name},</span>{" "}
              {speaker.description}
            </p>
          </div>
          <div className="profile-image">
            <img src={speaker.image} alt={speaker.name} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Speakers;
